<template>
  <div class="table -stats">
    <div class="t-body">
      <div class="t-head">
        <div class="-row">
          <div class="-cell">Дата</div>
          <div class="-cell">Начислено</div>
          <div class="-cell">Нал</div>
          <div class="-cell">Оф зп</div>
          <div class="-cell">НДФЛ</div>
          <div class="-cell">Выдано</div>
        </div>
      </div>
      <div v-if="stats.length" class="t-data">
        <div
          @click="toggleRow(i)"
          v-for="(s, i) in stats"
          :key="s.id"
          class="-row -multi"
          :class="{
            '-open': s.open,
            '-hide': allRowsEmpty(s),
            '-no_payout': payoutEmpty(s)
          }"
        >
          <label>
            <span>{{
              $moment(s.date).format(mobile ? "MMM YY" : "MMMM YYYY")
            }}</span>
            <span>{{ s.payroll ? $formatNumber(s.payroll) : "" }}</span>
            <span
              ><b>{{ $formatNumber(summary(s)) }}</b></span
            >
          </label>
          <div
            v-for="d in s.days"
            class="-row"
            :key="d.id"
            :class="{ '-hide': emptyRow(d) }"
          >
            <div class="-cell">
              {{ $moment(d.date).format(mobile ? "DD MMM" : "DD MMMM") }}
            </div>
            <div class="-cell">.</div>
            <div class="-cell">{{ $formatNumber(d.cashout) }}</div>
            <div class="-cell">{{ $formatNumber(d.cardout) }}</div>
            <div class="-cell">{{ $formatNumber(d.payout) }}</div>
          </div>
        </div>
        <div v-if="counters" class="t-sum -row">
          <div class="-cell">{{ hideAverage ? "" : "В среднем" }}</div>
          <div class="-cell">{{ $formatNumber(counters.payrollAverage) }}</div>
          <div class="-cell">
            <b>{{ $formatNumber(counters.payoutAverage) }}</b>
          </div>
        </div>
      </div>
      <p class="no_data" v-else>Нет данных</p>
    </div>
  </div>
</template>
<script>
export default {
  props: ["stats", "counters", "hideAverage"],
  data() {
    return {
      rows: [],
      mobile: false
    };
  },
  computed: {
    isCurrentYear: () => year => {
      return (
        new Date(year).getYear() === new Date(new Date().getTime()).getYear()
      );
    }
  },
  methods: {
    payoutEmpty(r) {
      let sum = 0;
      r.days.forEach(d => (sum = sum + (d.cashout + d.cardout + d.payout)));
      return sum === 0;
    },
    allRowsEmpty(r) {
      let sum = 0;
      r.days.forEach(d => (sum = sum + (d.cashout + d.cardout + d.payout)));
      if (r.payroll) sum = sum + parseInt(r.payroll);
      return sum === 0;
    },
    emptyRow(d) {
      let sum = 0;
      try {
        sum = (d.cashout || 0) + (d.cardout || 0) + (d.payout || 0);
      } catch (e) {
        void e;
      }
      return sum === 0;
    },
    summary(month) {
      if (month.days.length)
        return month.days
          .map(d => (d.cashout || 0) + (d.cardout || 0) + (d.payout || 0))
          .reduce((acc, v) => acc + (v || 0));
      else return 0;
    },
    toggleRow(index) {
      this.stats[index].open = !this.stats[index].open;
    }
  },
  beforeMount() {
    this.mobile = this.$mediaQuery() === "mobile";
  }
};
</script>
